/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import {
  Translations,
  convertStringToArrayForOption,
  convertStringToArrayForRadio,
  safeGet,
  savePageStateInSessionStorage
} from '../../../../../utils';

// constant
import { FORM_REFS, SWEEP_TYPES } from '../../../../../constants';
// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../../../restClient';
import { resetCountryInfo } from '../../../../createAcase/actions/actionCreator';
// children
import Dynamicform from '../../../../common/Dynamicform/dynamicForm';
import MultiLineSelect from '../../../../common/MultiLineSelect';
import NavListAccordion from '../../../../common/NavListAccordion/NavListAccordion';
import Radiobutton from '../../../../common/Radio/radioButton';
import SimpleDropdown from '../../../../common/SimpleDropdown';
//action Creator
import {
  reSetNewSweepActiveTabIndex,
  setCrossBorder,
  setSowNewSweepActiveTabIndex
} from '../../../actions/actionCreator';
//style
import NavListAccordionWrapper from '../../../../common/CashFlowForecastingAccordion/cashFlowForecastingAccordion';
import './styles.css';

const {
  ZERO_BALANCING_SWEEP,
  FIXED_AMOUNT_SWEEP,
  DYNAMIC_SWEEP_STANDARD,
  DYNAMIC_SWEEP_ENHANCED,
  DYNAMIC_SWEEP_ENHANCED_ZBA
} = SWEEP_TYPES;

class Rules {
  static get SHOW_OTHER_SWEEP_INSTRUCTIONS_FORM() {
    return [
      ZERO_BALANCING_SWEEP,
      FIXED_AMOUNT_SWEEP,
      DYNAMIC_SWEEP_STANDARD,
      DYNAMIC_SWEEP_ENHANCED,
      DYNAMIC_SWEEP_ENHANCED_ZBA
    ];
  }
}

class AddSweepInstruction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCustAck: false,
      currentSweepInstruction: {
        id: (this.props.match.params && this.props.match.params.sweepId) || ''
      },
      mode: 'create',
      availableAccountsList: [],
      sweepParticipantsAccounts: [],
      standardSweepInstructions: {},
      accountInterestLimits: [],
      ccrBilateralLimits: {},
      ccrInfo: {},
      otherSweepDetails: {},
    };

    this.taxanomyURL = '/product/taxonomies/sweepType';
  }
  isReadOnly = () => {
    const { customer, caseMenu } = this.props || {}
    return customer && (customer.roleDetails.customer || this.state.isCustAck) ||
      (caseMenu && caseMenu.isEditing &&
        (caseMenu.editingUserEmail !== customer.emailAddress))
  }

  getSweepDetails = async () => {
    const { sweepId, glsId } = (this.props.match && this.props.match.params) || {};
    if (sweepId && this.props.sowAgent && this.props.sowAgent.id) {
      const apiUrl = `/sows/${glsId}/getSweepDetail/${sweepId}`
      return await eapiClient(apiUrl).then(({ data }) => {
        if (data.responseData && data.responseData.length) {
          const [sweepDetails] = data.responseData
          this.loadPageState(sweepDetails)
          this.loadSweepInstructionTabStatus()
        }
      })
    }
  }

  loadPageState = (sweepDetails) => {
    const currency = safeGet(sweepDetails, 'sweepParticipantsAccounts.currency');
    if (currency.value !== undefined) {
      this.fetchAvailableAccountsList(currency.value);
    }
    this.loadSweepInstructionsPageState(sweepDetails);
  }

  loadSweepInstructionsPageState = (sweepDetails = {}) => {
    const {
      sweepParticipantsAccounts,
      standardSweepInstructions,
      otherSweepInstructions,
      accountInterestLimits,
      ccrInfo,
      ccrBilateralLimits,
    } = sweepDetails;
    this.setState({
      sweepParticipantsAccounts,
      standardSweepInstructions,
      otherSweepInstructions,
      accountInterestLimits,
      ccrInfo,
      ccrBilateralLimits,
      currentSweepInstruction: sweepDetails,
    });
  }

  translateWordForRadio = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForRadio(currentWord);
    return convertedArray;
  }
  translateWordForOption = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForOption(currentWord);
    return convertedArray;
  }

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  componentWillMount() {
    this.getSweepDetails().then(() => {
      this.getCashConCurrencyTaxonomy()

      aemHostClient("/aemData/formData/json_sow-sweep-instructions-all-closed")
        .then(({ data }) => {
          this.setState({ pageJson: data });
          this.getTaxanomyUrl();
        });

      aemHostClient("/aemData/formData/json_sow-gls-sweep-participants-accounts-form")
        .then(({ data }) => {
          this.setState({ sweepAccountsPageJson: data.guideContainer.rootPanel.items });
        });
    })
  }

  getCashConCurrencyTaxonomy = () => {
    taxonomyHostClient("/product/taxonomies/urn:hsbc:cmb:gdocs:products:taxonomies:AllCurrency")
      .then(({ data }) => {
        this.setState({ currencyList: data.responseData.classificationNodes });
      });
  }

  componentDidMount() {
    this.props.resetCountryInfo();
    var getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    var getCurrentDropDownValue = window.sessionStorage.getItem('key' + getCurrentDropDown);
    // if(getCurrentDropDown !== null){
    //   var getCurrentDropDownName =  getCurrentDropDown.substring(0,getCurrentDropDown.length -1);
    // }
    let sweepParticipantsAccounts = { ...this.state.sweepParticipantsAccounts }
    if (getCurrentDropDown === 'masterAccount' && getCurrentDropDownValue !== null) {
      //sweepParticipantsAccounts.masterAccount[getCurrentDropDownIndex] = getCurrentDropDownValue;

      this.setState({
        sweepParticipantsAccounts: {
          ...this.state.sweepParticipantsAccounts,
          masterAccount: getCurrentDropDownValue
        }
      });
    } else if (getCurrentDropDown === 'subAccount' && getCurrentDropDownValue !== null) {
      this.setState({
        sweepParticipantsAccounts: {
          ...this.state.sweepParticipantsAccounts,
          subAccount: getCurrentDropDownValue
        }
      });

    }
    window.sessionStorage.removeItem("getCurrentDropDown");
    window.sessionStorage.removeItem('key' + getCurrentDropDown);
    if (this.props.savedSow.statusValue === 'Acknowledged By Customer' || this.props.savedSow.statusValue === 'Sent to Implementation Manager') {
      this.setState({ isCustAck: true });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      this.getTaxanomyUrl();
    }
  }



  getTaxanomyUrl = () => {
    this.taxanomyURL = this.translations(this.state.pageJson.par.aemform_sweepAccounts.glsCashConTaxonomy);
    taxonomyHostClient(this.taxanomyURL)
      .then(({ data }) => {
        this.setState({ sweepTypes: data.responseData.classificationNodes });
      });
    this.getAccountTaxanomy()
  }

  getAccountTaxanomy = () => {
    let availableAccountsList = this.state.availableAccountsList;
    taxonomyHostClient(this.translations(this.state.pageJson.par.aemform_sweepAccounts.countryTaxonomy))
      .then(({ data }) => {
        if (data.responseData !== undefined) {
          let currentListCountries = data.responseData.classificationNodes;
          if (availableAccountsList !== undefined) {
            availableAccountsList = availableAccountsList.map(item => {
              currentListCountries.filter(countItem => {
                if ('country' in item) {
                  if (countItem.id === item.country.value) {
                    item.country.name = countItem.name
                  }
                }
                return item;
              });

              this.setState([...availableAccountsList]);
            });
          }
        }
      });
  }

  fetchAvailableAccountsList = (currencyId) => {
    var { caseId, productId } = this.props.match.params;
    let currencyName = currencyId.split(':').pop();
    this.setState({
      ccrBilateralLimits: {
        ...this.state.ccrBilateralLimits,
        currency: currencyName
      }
    })

    eapiClient(`/sows/${this.props.savedSow.sowId}/currency/${currencyId}/getAccountInfoWithCurrency`)
      .then(({ data }) => {
        var accountListFilter = [];
        var accountList = data.responseData
        var key = window.sessionStorage.getItem("getCurrentDropDown");
        if (key === 'masterAccount') {
          eapiClient(`/product/taxonomies/cashConcentrationCountries`)
            .then(({ data }) => {
              var countries = data.responseData.classificationNodes;
              accountList.filter((account, index) => {
                countries.filter(countryList => {
                  if (countryList.id.split(':').reverse()[1] === account.location.value.split(':').reverse()[1]) {
                    accountListFilter.push(account);
                  }
                })
              })
              this.setState({ availableAccountsList: accountListFilter });
            });
        } else {
          this.setState({ availableAccountsList: accountList });
        }
      });
  }

  setSweepParticipantsData = (event) => {
    let sweepParticipantsAccounts = { ...this.state.sweepParticipantsAccounts };
    if (event.target.name === "currency") {
      this.fetchAvailableAccountsList(event.target.value);
    }
    sweepParticipantsAccounts = {
      ...sweepParticipantsAccounts,
      masterAccount: '',
      subAccount: ''
    }
    if (event.target.name === "sweepType" || event.target.name === "currency") {
      sweepParticipantsAccounts[event.target.name] = {
        name: event.nativeEvent.target[event.nativeEvent.target.selectedIndex].text,
        value: event.target.value
      }
    }
    this.setState({
      sweepParticipantsAccounts
    });
  }

  handleSweepParticipantsRadioChange = (value, name) => {
    var sweepParticipantsAccounts;
    if (name === 'cashConReporting' && value === false) {
      sweepParticipantsAccounts = {
        ...this.state.sweepParticipantsAccounts,
        cashConReporting: false,
        bilateralLimits: false,
        accountLimits: false,
        groupLimits: false
      };
    } else {
      sweepParticipantsAccounts = {
        ...this.state.sweepParticipantsAccounts,
        [name]: value
      };
    }
    if (name === 'accountRegion') {
      this.props.setCrossBorder(value);
    }
    this.setState({ sweepParticipantsAccounts });
  }

  handleMasterAccountChange = (masterAccount) => {
    this.setState({
      sweepParticipantsAccounts: {
        ...this.state.sweepParticipantsAccounts,
        masterAccount: masterAccount.id
      }
    });
  }

  handleSubAccountChange = (subAccount) => {
    this.setState({
      sweepParticipantsAccounts: {
        ...this.state.sweepParticipantsAccounts,
        subAccount: subAccount.id
      }
    });
  }

  handleAccountEditClick = (detail, status) => {
    var { productId } = this.props.match.params;
    if (detail !== undefined) {
      savePageStateInSessionStorage(this.state, this.props.history.location.pathname);
      this.props.history.push({
        pathname: "/case-body/create-new-other-account/" + productId + "/" + detail,
        state: { key: status }
      });
    }
  }

  getSelectedAccounts = () => {
    var selectedAccounts = [];
    if (this.state.sweepParticipantsAccounts.masterAccount) {
      selectedAccounts.push(this.state.sweepParticipantsAccounts.masterAccount);
    }
    if (this.state.sweepParticipantsAccounts.subAccount) {
      selectedAccounts.push(this.state.sweepParticipantsAccounts.subAccount);
    }
    return selectedAccounts;
  }

  renderSweepParticipantsAndAccountsForm = () => {
    var { productId } = (this.props.match && this.props.match.params) || {};
    let availableAccountsListForMaster;
    let sweepParticipantsAndAccountsJsx = "";

    // if (this.state.availableAccountsList !== undefined && this.state.availableAccountsList.length > 0) {
    //   availableAccountsListForMaster = this.state.availableAccountsList.filter(item => item.bankName === 'HSBC' || item.hsbcEntity !== undefined)
    // }
    this.state.sweepAccountsPageJson !== undefined ?
      sweepParticipantsAndAccountsJsx = (
        <div className="sweep-participants-and-accounts-section">
          <div className="form-row">
            <div className="form-column">
              <label>{this.translations(this.state.sweepAccountsPageJson.guidedropdownlist_sweepType.title)}</label>
            </div>
            <div className="form-column">
              <SimpleDropdown
                name="sweepType"
                options={this.state.sweepTypes || []}
                optionTextSelector="name"
                defaultValue={this.translations(this.state.sweepAccountsPageJson.guidedropdownlist_sweepType.value)}
                disabled={this.isReadOnly()}
                value={this.state.sweepParticipantsAccounts && this.state.sweepParticipantsAccounts.sweepType ? this.state.sweepParticipantsAccounts.sweepType.value : ''}
                _onChange={this.setSweepParticipantsData}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-column">
              <label>{this.translations(this.state.sweepAccountsPageJson.guideradiobutton_crossBorderDomestic.title)}</label>
            </div>
            <div className="form-column">
              <label className="radio-label">
                {this.translateWordForRadio(this.state.sweepAccountsPageJson.guideradiobutton_crossBorderDomestic.options)[0].split('=')[1]}
                <Radiobutton
                  setInputvalue={this.handleSweepParticipantsRadioChange}
                  name="accountRegion"
                  disabled={this.isReadOnly()}
                  _value={this.state.sweepParticipantsAccounts && this.state.sweepParticipantsAccounts.accountRegion}
                  value="crossBorder"
                />
              </label>
              <label className="radio-label">
                {this.translateWordForRadio(this.state.sweepAccountsPageJson.guideradiobutton_crossBorderDomestic.options)[1].split('=')[1]}
                <Radiobutton
                  setInputvalue={this.handleSweepParticipantsRadioChange}
                  name="accountRegion"
                  disabled={this.isReadOnly()}
                  _value={this.state.sweepParticipantsAccounts && this.state.sweepParticipantsAccounts.accountRegion}
                  value="domestic"
                />
              </label>
            </div>
          </div>
          <div className="form-row">
            <div className="form-column">
              <label>{this.translations(this.state.sweepAccountsPageJson.guidedropdownlist_currency.title)}</label>
            </div>
            <div className="form-column">
              <SimpleDropdown
                name="currency"
                options={this.state.currencyList || []}
                optionTextSelector="name"
                defaultValue={this.translations(this.state.sweepAccountsPageJson.guidedropdownlist_currency.value)}
                disabled={this.isReadOnly()}
                value={this.state.sweepParticipantsAccounts && this.state.sweepParticipantsAccounts.currency ? this.state.sweepParticipantsAccounts.currency.value : ''}
                _onChange={this.setSweepParticipantsData}
              />
            </div>
          </div>
          {
            this.state.sweepParticipantsAccounts && this.state.sweepParticipantsAccounts.currency !== undefined ? (
              <div className="form-row">
                <div className="form-column">
                  <label>{this.translations(this.state.sweepAccountsPageJson.guidedropdownlist_masterAccount.title)}</label>
                </div>
                <div className="form-column">
                  {<MultiLineSelect
                    requiredFields={{
                      "row1": ["accountNumber", "location", "currency"],
                      "row2": ["entityName"],
                      "row3": ["bankName", "hsbcBankName", "accountTitle", "tempRefrenceId"]
                    }}
                    requiredFieldsPrefixes={{
                      "row1": ["", "", "", ""],
                      "row2": [""],
                      "row3": ["", ""]
                    }}
                    multiAccount={true}
                    data={this.state.availableAccountsList.filter(acc => !acc.isThirdPartyAccount).map(el => ({
                      ...el, entityName: ((this.props.sowEntityList.find(en => en.id === el.sowEntityId) &&
                        this.props.sowEntityList.find(en => en.id === el.sowEntityId).registeredName) || '')
                    })) || []}
                    value={this.state.sweepParticipantsAccounts && this.state.sweepParticipantsAccounts.masterAccount}
                    defaultValue={this.translations(this.state.sweepAccountsPageJson.guidedropdownlist_currency.value)}
                    isDisable={this.isReadOnly()}
                    disabledOptions={this.getSelectedAccounts()}
                    onEdit={this.handleAccountEditClick.bind(this, this.state.sweepParticipantsAccounts.masterAccount, 'masterAccount')}
                    _onChange={this.handleMasterAccountChange}
                    className="gdoc-cash-con-multiline-dropdown"
                  />
                  }
                  {/* <PersistLink
                    className={"mrg-left " + (this.props.customer.roleDetails.customer ? 'disabled' : '')}
                    to={`/case-body/create-new-other-account/${productId}`}
                    history={this.props.history}
                    state={this.state}
                    data="masterAccount"
                  >
                    <i className="icon icon-add"></i>
                    {this.translations(this.state.sweepAccountsPageJson.static_text_addOtherAccount.title)}
                  </PersistLink> */}
                </div>
              </div>)
              : ''
          }
          {
            this.state.sweepParticipantsAccounts && this.state.sweepParticipantsAccounts.currency !== undefined ? (
              <div className="form-row no-bottom-margin">
                <div className="form-column">
                  <label>{this.translations(this.state.sweepAccountsPageJson.guidedropdownlist_subAccount.title)}</label>
                </div>
                <div className="form-column">
                  {<MultiLineSelect
                    requiredFields={{
                      "row1": ["accountNumber", "location", "countryOfIncorporation", "currency"],
                      "row2": ["entityName"],
                      "row3": ["bankName", "hsbcBankName", "accountTitle", "tempRefrenceId"]
                    }}
                    multiAccount={true}
                    requiredFieldsPrefixes={{
                      "row1": ["", "", "", ""],
                      "row2": [""],
                      "row3": ["", ""]
                    }}
                    data={this.state.availableAccountsList.map(el => ({
                      ...el, entityName: ((this.props.sowEntityList.find(en => en.id === el.sowEntityId) &&
                        this.props.sowEntityList.find(en => en.id === el.sowEntityId).registeredName) || '')
                    })) || []}
                    value={this.state.sweepParticipantsAccounts && this.state.sweepParticipantsAccounts.subAccount}
                    defaultValue={this.translations(this.state.sweepAccountsPageJson.guidedropdownlist_currency.value)}
                    isDisable={this.isReadOnly()}
                    disabledOptions={this.getSelectedAccounts()}
                    onEdit={this.handleAccountEditClick.bind(this, this.state.sweepParticipantsAccounts.subAccount, 'subAccount')}
                    _onChange={this.handleSubAccountChange}
                    className="gdoc-cash-con-multiline-dropdown"
                  />}
                  {/* <PersistLink
                    className={"mrg-left " + (this.props.customer.roleDetails.customer ? 'disabled' : '')}
                    to={`/case-body/create-new-other-account/${productId}`}
                    history={this.props.history}
                    state={this.state}
                    disabled={this.props.customer.roleDetails.customer}
                    data="subAccount"
                  >
                    <i className="icon icon-add" ></i>
                    {this.translations(this.state.sweepAccountsPageJson.static_text_addOtherAccount.title)}
                  </PersistLink> */}
                </div>
              </div>)
              : ''
          }
          <hr></hr>
          <label className="section-label">
            <div>{this.translations(this.state.sweepAccountsPageJson.static_text_cashConReporting.text)}</div>
            <div>{this.translations(this.state.sweepAccountsPageJson.static_text_cashConReporting.subText || "(Inter Company Solutions)")}</div>
          </label>
          <div className="form-row">
            <div className="form-column">
              <label>
                <div>{this.translations(this.state.sweepAccountsPageJson.static_text_cashConReporting.title)}</div>
                <div>{this.translations(this.state.sweepAccountsPageJson.static_text_cashConReporting.subText || "(Inter Company Solutions)")}</div>
              </label>
            </div>
            <div className="form-column">
              <label className="radio-label">
                {this.translateWordForRadio(this.state.sweepAccountsPageJson.static_text_cashConReporting.options)[0].split("=")[1]}
                <Radiobutton
                  setInputvalue={this.handleSweepParticipantsRadioChange}
                  name="cashConReporting"
                  disabled={this.isReadOnly()}
                  _value={this.state.sweepParticipantsAccounts && this.state.sweepParticipantsAccounts.cashConReporting}
                  value="true"
                />
              </label>
              <label className="radio-label">
                {this.translateWordForRadio(this.state.sweepAccountsPageJson.static_text_cashConReporting.options)[1].split("=")[1]}
                <Radiobutton
                  setInputvalue={this.handleSweepParticipantsRadioChange}
                  name="cashConReporting"
                  disabled={this.isReadOnly()}
                  _value={this.state.sweepParticipantsAccounts && this.state.sweepParticipantsAccounts.cashConReporting}
                  value="false"
                />
              </label>
            </div>
          </div>
          {
            this.state.sweepParticipantsAccounts && this.state.sweepParticipantsAccounts.cashConReporting ?
              <div className="form-row" key="ccr-bilateral-limits">
                <div className="form-column">
                  <label>{this.translations(this.state.sweepAccountsPageJson.guideradiobutton_bilateralLimits.title)}</label>
                </div>
                <div className="form-column">
                  <label className="radio-label">
                    {this.translateWordForRadio(this.state.sweepAccountsPageJson.guideradiobutton_bilateralLimits.options)[0].split("=")[1]}
                    <Radiobutton
                      setInputvalue={this.handleSweepParticipantsRadioChange}
                      name="bilateralLimits"
                      disabled={this.isReadOnly()}
                      _value={this.state.sweepParticipantsAccounts && this.state.sweepParticipantsAccounts.bilateralLimits}
                      value="true"
                    />
                  </label>
                  <label className="radio-label">
                    {this.translateWordForRadio(this.state.sweepAccountsPageJson.guideradiobutton_bilateralLimits.options)[1].split("=")[1]}
                    <Radiobutton
                      setInputvalue={this.handleSweepParticipantsRadioChange}
                      name="bilateralLimits"
                      disabled={this.isReadOnly()}
                      _value={this.state.sweepParticipantsAccounts && this.state.sweepParticipantsAccounts.bilateralLimits}
                      value="false"
                    />
                  </label>
                </div>
              </div>
              : null
          }
          <div className="gdocs-clear-float"></div>
          <div key="buttons-wrapper" className="form-buttons-save-section">
            <div className="form-buttons-wrapper">
              <button
                className="gdocs-btn-submit"
                onClick={this.onSweepPartcipantsAccountTabDataSubmit}
                disabled={this.isReadOnly()}
              >{this.translations(this.state.sweepAccountsPageJson.guidebutton_save.text)}</button>
            </div>
          </div>
        </div >) : ''
    return sweepParticipantsAndAccountsJsx;
  }

  getStandardSweepInstructionsData = (standardSweepInstructions) => {
    this.setState({ standardSweepInstructions });
  }

  renderStandardSweepInstructionsForm = () => {
    var formData = {}, mode = 'edit';
    if (this.state.currentSweepInstruction !== undefined && this.state.standardSweepInstructions !== undefined) {
      if (Object.keys(this.state.standardSweepInstructions).length) {
        mode = 'edit';
        formData = { ...this.state.standardSweepInstructions };
        if ('forcePartialReject' in formData === false) {
          formData.forcePartialReject = {
            name: 'Forced',
            value: 'forced'
          }
        }
      }
      else {
        formData.forcePartialReject = {
          name: 'Forced',
          value: 'forced'
        }
        formData.backValuedSweepOption = {
          name: "Yes",
          value: "yes"
        }
        formData.reverseSweepOption = {
          name: "No",
          value: 'no'
        }
        formData.masterHolidaySweepOption = {
          name: "No",
          value: 'no'
        }
        formData.sweepFrequency = {
          frequencyDetails: {
            name: "",
            value: ""
          },
          frequencyType: {
            name: "Daily",
            value: "urn:hsbc:cmb:gdocs:products:taxonomies:frequency:daily"
          }
        }
      }
    } else {
      formData.forcePartialReject = {
        name: 'Forced',
        value: 'forced'
      }
      formData.backValuedSweepOption = {
        name: "Yes",
        value: "yes"
      }
      formData.reverseSweepOption = {
        name: "No",
        value: 'no'
      }
      formData.masterHolidaySweepOption = {
        name: "No",
        value: 'no'
      }
      formData.sweepFrequency = {
        frequencyDetails: {
          name: "",
          value: ""
        },
        frequencyType: {
          name: "Daily",
          value: "urn:hsbc:cmb:gdocs:products:taxonomies:frequency:daily"
        }
      }
    }
    const properties = {
      sweepId: this.props.match.params.sweepId,
      glsCashconId: this.props.match.params.productId,
      caseId: this.props.match.params.caseId,
      formData,
      editType: 'sweep-standard-sweep-instructions',
      pathname: this.props.history.location.pathname
    };
    if (this.state.pageJson !== undefined && this.state.pageJson.par.aemform_standardSweepInstructions !== undefined) {
      var aemform = this.state.pageJson.par.aemform_standardSweepInstructions;
      var formRef = this.state.pageJson.par.aemform_standardSweepInstructions.formRef;
      if (aemform !== undefined && formRef !== undefined) {
        var url = FORM_REFS[formRef];
        return (
          <section className="sow-standard-sweep-form">
            <Dynamicform
              mode={mode}
              properties={properties}
              hideButtons={true}
              saveButton={true}
              onFormSubmit={this.onStandardSweepInstructionsTabDataSubmit}
              getFormData={this.getStandardSweepInstructionsData}
              history={this.props.history}
              url={url}
              lang={this.props.lang.currentLang.lang}
              translatedData={this.props.lang.translatedData}
              sow
              customer={this.props.customer}
              isCustAck={this.state.isCustAck}
            />
          </section>
        );
      }
    }
  }

  showOtherSweepInstructionsForm = () => {
    return Rules.SHOW_OTHER_SWEEP_INSTRUCTIONS_FORM.indexOf(this.state.sweepParticipantsAccounts && this.state.sweepParticipantsAccounts.sweepType.value) === -1;
  }

  getOtherSweepInstructionsData = (otherSweepInstructions) => {
    this.setState({ otherSweepInstructions });
  }

  renderOtherSweepInstructionsForm = () => {
    var formData, mode;
    if (this.state.currentSweepInstruction !== undefined && this.state.otherSweepInstructions !== undefined && Object.keys(this.state.otherSweepInstructions).length > 0) {
      mode = 'edit';
      formData = { ...this.state.otherSweepInstructions };
      formData.creditFirstGroupSweepRule = {
        name: 'NA',
        value: 'na'
      }
    } else {
      formData = {};
    }
    const properties = {
      sweepId: this.props.match.params.sweepId,
      glsCashconId: this.props.match.params.productId,
      caseId: this.props.match.params.caseId,
      formData,
      editType: 'sweep-other-sweep-instructions',
      dependentFields: [safeGet(this.state.sweepParticipantsAccounts, 'sweepType.value')],
      pathname: this.props.history.location.pathname
    };
    if (this.state.pageJson !== undefined && this.state.pageJson.par.aemform_otherSweepInstructions !== undefined) {
      var aemform = this.state.pageJson.par.aemform_otherSweepInstructions;
      var formRef = this.state.pageJson.par.aemform_otherSweepInstructions.formRef;
      if (aemform !== undefined && formRef !== undefined) {
        var url = FORM_REFS[formRef];
        return (
          <Dynamicform
            mode={mode}
            properties={properties}
            hideButtons={true}
            saveButton={true}
            onFormSubmit={this.onOtherSweepInstructionsTabDataSubmit}
            getFormData={this.getOtherSweepInstructionsData}
            history={this.props.history}
            url={url}
            lang={this.props.lang.currentLang.lang}
            translatedData={this.props.lang.translatedData}
            sow
            customer={this.props.customer}
            isCustAck={this.state.isCustAck}
          />
        );
      }
    }
  }

  showOtherSweepOptionsForm = () => {
    return true;
  }

  getAccountInterestTieringData = (index, accountInterestLimitData) => {
    if ("currency" in accountInterestLimitData && accountInterestLimitData.currency === '') {
      const availAcc = this.state.availableAccountsList.find(acc => this.state.accountInterestLimits && this.state.accountInterestLimits[index] && this.state.accountInterestLimits[index].accountId === acc.id)
      if (availAcc && availAcc.currency) {
        accountInterestLimitData.currency = availAcc.currency.name
      }
    }
    const accountInterestLimits = [...this.state.accountInterestLimits];
    accountInterestLimits[index] = accountInterestLimitData;
    this.setState({ accountInterestLimits });
  }

  renderAccountInterestTieringForm = () => {
    const associatedAccountsInterestTier = Array.isArray(this.state.accountInterestLimits) &&
      this.state.accountInterestLimits.filter(acc => this.state.sweepParticipantsAccounts &&
        (acc.accountId === this.state.sweepParticipantsAccounts.masterAccount || acc.accountId === this.state.sweepParticipantsAccounts.subAccount))
    const bannerJSON = (this.state.accountLimitsFormSchema && this.state.accountLimitsFormSchema.guideContainer && this.state.accountLimitsFormSchema.guideContainer.rootPanel
      && this.state.accountLimitsFormSchema.guideContainer.rootPanel.items && this.state.accountLimitsFormSchema.guideContainer.rootPanel.items.notification_accountInterestRateBanner) || {}
    return (
      <article>
        {this.renderNotificationBanner(bannerJSON)}
        {Array.isArray(associatedAccountsInterestTier) && associatedAccountsInterestTier.map((tier, index) => {
          const { accountNumber = '', currency = '', location = '', countryOfIncorporation = '' } = this.state.availableAccountsList.find(acc => acc.id === tier.accountId) || {}
          return <section className='sow-cashcon-input-form-ccr-rate-box__combo-box'>
            {this.renderEachAccountInterestAndTiering({ ...tier, accountNumber, currency: typeof currency === "object" ? currency.name : currency, location: location === "string" ? countryOfIncorporation : location }, index)}
          </section>
        })}
        <section className="gdocs-clear-float"></section>
        <section key="buttons-wrapper" className="form-buttons-save-section">
          <section className="form-buttons-wrapper">
            <button
              className="gdocs-btn-submit"
              onClick={this.onAccountInterestTieringTabDataSubmit}
              disabled={this.props.customer && (this.props.customer.roleDetails.customer || this.state.isCustAck)}
            >{this.translations("Refresh")}
            </button>
          </section>
        </section>
      </article>
    )
  }

  renderNotificationBanner = ({ name = '', label1 = '', label2 = '', label3 = '', subLabels = '[]' }) => {
    let listItems
    try {
      listItems = subLabels && JSON.parse(this.translations(subLabels))
    } catch (err) {
      console.log(err)
    }
    return (
      <article>
        <h5><strong>
          {this.translations(label1)}
        </strong></h5>
        <h5><strong>
          {this.translations(label2)}
        </strong></h5>
        <ul>
          {Array.isArray(listItems) && listItems.map((item, itemIndex) => {
            return <li key={name + "-sublabels-" + itemIndex}><h5><strong>{item}</strong></h5></li>
          })}
        </ul>
        <h5><strong>{this.translations(label3)}</strong></h5>
      </article>
    )
  }

  getCCRInterestData = (ccrInfo) => {
    this.setState({ ccrInfo });
  }

  renderCCRInterestForm = () => {
    var formData, mode;
    var currency = this.state.currentSweepInstruction.sweepParticipantsAccounts !== undefined && this.state.currentSweepInstruction.sweepParticipantsAccounts.currency !== undefined
      ? `${this.state.currentSweepInstruction.sweepParticipantsAccounts.currency.name}`
      : ''
    var ccrRefName = `${"ccrInfo" in this.state && this.state.ccrInfo !== undefined && 'ccrRefId' in this.state.ccrInfo && this.state.ccrInfo.ccrRefId !== undefined ? this.state.ccrInfo.ccrRefId : ''} ${currency !== undefined ? currency : ''}`
    var updateCcrObj = {
      ...this.state.ccrInfo,
      ccrRefId: this.state.currentSweepInstruction !== undefined && this.state.ccrInfo !== undefined && ccrRefName !== "undefined " ? ccrRefName : ' '
    }
    if (this.state.currentSweepInstruction !== undefined && this.state.ccrInfo !== undefined) {
      mode = 'edit';
      if (this.state.ccrInfo.interestPeriod === undefined) {
        formData = {
          ...updateCcrObj,
          interestPeriod: {
            frequencyType: {
              name: "Monthly",
              value: "urn:hsbc:cmb:gdocs:products:taxonomies:frequency:monthly"
            },
            frequencyDetails: {
              name: '',
              value: ''
            }
          },
          csrAppliedInterestCharges: 'N/A',
          csrAppliedInterestEarnings: 'N/A',
          openingAccuredInterest: 'N/A',
          openingLoanPosition: 'N/A'
        };
      } else {
        formData = { ...updateCcrObj };
      }

    } else {
      formData = {
        ...updateCcrObj,
        interestPeriod: {
          frequencyType: {
            name: "Monthly",
            value: "urn:hsbc:cmb:gdocs:products:taxonomies:frequency:monthly"
          },
          frequencyDetails: {
            name: '',
            value: ''
          }
        },
        csrAppliedInterestCharges: 'N/A',
        csrAppliedInterestEarnings: 'N/A',
        openingAccuredInterest: 'N/A',
        openingLoanPosition: 'N/A',
      };
    }
    // csrAppliedInterestEarnings:'N/A',
    // csrAppliedInterestCharges:'N/A',
    const properties = {
      sweepId: this.props.match.params.sweepId,
      glsCashconId: this.props.match.params.productId,
      caseId: this.props.match.params.caseId,
      formData,
      editType: 'sweep-ccr-interests',
      pathname: this.props.history.location.pathname
    };
    if (this.state.pageJson !== undefined && this.state.pageJson.par.aemform_ccrInterest !== undefined) {
      var aemform = this.state.pageJson.par.aemform_ccrInterest;
      var formRef = this.state.pageJson.par.aemform_ccrInterest.formRef;
      if (aemform !== undefined && formRef !== undefined) {
        var url = FORM_REFS[formRef];
        return (
          <Dynamicform
            mode={'edit'}
            properties={properties}
            hideButtons={true}
            saveButton={true}
            onFormSubmit={this.onCcrInfoTabDataSubmit}
            getFormData={this.getCCRInterestData}
            history={this.props.history}
            url={url}
            lang={this.props.lang.currentLang.lang}
            translatedData={this.props.lang.translatedData}
            sow
            customer={this.props.customer}
            isCustAck={this.state.isCustAck}
          />
        );
      }
    }
  }

  getBilateralLimitsData = (ccrBilateralLimits) => {
    this.setState({ ccrBilateralLimits });
  }

  renderBilateralLimitsForm = () => {

    var formData = {}, mode;
    let lendingLimitBreachAction = {
      name: "N/A",
      value: "na"
    }
    let borrowingLimitBreachAction = {
      name: "N/A",
      value: "na"
    }

    if (this.state.currentSweepInstruction !== undefined && this.state.ccrBilateralLimits !== undefined && Object.keys(this.state.ccrBilateralLimits).length > 0) {
      mode = 'edit';
      formData = { ...this.state.ccrBilateralLimits };

      if ('lendingLimitBreachAction' in formData === false) {
        formData.lendingLimitBreachAction = lendingLimitBreachAction;
      } if ('borrowingLimitBreachAction' in formData === false) {
        formData.borrowingLimitBreachAction = borrowingLimitBreachAction;
      } if ('subAccountLendingLimit' in formData === false) {
        formData.subAccountLendingLimit = 'N/A';
      } if ('subAcountBorrowingLimit' in formData === false) {
        formData.subAcountBorrowingLimit = 'N/A';
      }
    } else {
      formData.subAccountLendingLimit = 'N/A';
      formData.subAcountBorrowingLimit = 'N/A';
      formData.lendingLimitBreachAction = lendingLimitBreachAction;
      formData.borrowingLimitBreachAction = borrowingLimitBreachAction;
    }
    const properties = {
      sweepId: this.props.match.params.sweepId,
      glsCashconId: this.props.match.params.productId,
      caseId: this.props.match.params.caseId,
      formData,
      editType: 'sweep-bilateral-limits',
      pathname: this.props.history.location.pathname
    };

    if (this.state.pageJson !== undefined && this.state.pageJson.par.aemform_ccrBilateralLimits !== undefined) {
      var aemform = this.state.pageJson.par.aemform_ccrBilateralLimits;
      var formRef = this.state.pageJson.par.aemform_ccrBilateralLimits.formRef;
      if (aemform !== undefined && formRef !== undefined) {
        var url = FORM_REFS[formRef];
        return (
          <Dynamicform
            mode={mode}
            properties={properties}
            hideButtons={true}
            saveButton={true}
            onFormSubmit={this.onCcrBilateralLimitsTabDataSubmit}
            getFormData={this.getBilateralLimitsData}
            history={this.props.history}
            url={url}
            lang={this.props.lang.currentLang.lang}
            translatedData={this.props.lang.translatedData}
            sow
            customer={this.props.customer}
            isCustAck={this.state.isCustAck}
          />
        );
      }
    }
  }

  loadSweepInstructionTabStatus = () => {
    this.props.getCashConStatus()
  }

  //sweep Participant sAccounts save and Refresh
  onSweepPartcipantsAccountTabDataSubmit = () => {
    let payload = new SweepPartcipantsAccountPayload(this.state.currentSweepInstruction);
    payload.setPayload(this.state);
    const { sweepId, glsId } = (this.props.match && this.props.match.params) || {};
    const apiUrl = `/sows/${glsId}/glses`

    if (sweepId && glsId) {
      eapiClient(apiUrl, {
        method: 'PUT',
        data: JSON.stringify({
          cashConcentration: {
            sweepInstructions: [payload.sweepInstruction],
          }
        })
      })
        .then(({ data }) => {
          if (data.responseData && data.responseData.cashConcentration && Array.isArray(data.responseData.cashConcentration.accountInterestLimits)) {
            const updatedLimits = data.responseData.cashConcentration.accountInterestLimits.filter(limit => (
              limit.accountId ===
              data.responseData.cashConcentration.sweepInstructions.find(sweep => sweep.id === this.state.currentSweepInstruction.id).sweepParticipantsAccounts.masterAccount ||
              limit.accountId ===
              data.responseData.cashConcentration.sweepInstructions.find(sweep => sweep.id === this.state.currentSweepInstruction.id).sweepParticipantsAccounts.subAccount))
            this.setState({
              accountInterestLimits: updatedLimits
            })
          }
          this.loadSweepInstructionTabStatus();
        });
    }
  }

  // Standard Sweep Instructions save and Refresh Click
  onStandardSweepInstructionsTabDataSubmit = (event) => {
    let payload = new StandardSweepInstructionsPayload(this.state.currentSweepInstruction);
    payload.setPayload(this.state);

    const { glsId } = (this.props.match && this.props.match.params) || {}
    const apiUrl = `/sows/${glsId}/glses`
    eapiClient(apiUrl, {
      method: 'PUT',
      data: JSON.stringify({
        cashConcentration: {
          sweepInstructions: [payload.sweepInstruction]
        }
      })
    })
      .then(({ data }) => {
        this.loadSweepInstructionTabStatus();
      });
  }

  // OtherSweepInstructions save & Refesh Click
  onOtherSweepInstructionsTabDataSubmit = (event) => {
    let payload = new OtherSweepInstructionsPayload(this.state.currentSweepInstruction);
    payload.setPayload(this.state);

    const { productId, glsId } = this.props.match.params;
    const apiUrl = `/sows/${glsId}/glses`
    eapiClient(apiUrl, {
      method: 'PUT',
      data: JSON.stringify({
        id: productId,
        cashConcentration: {
          sweepInstructions: [payload.sweepInstruction]
        }
      })
    })
      .then(({ data }) => {
        this.loadSweepInstructionTabStatus();
      });
  }

  // Account Interest & Tiering save & Refresh Click
  onAccountInterestTieringTabDataSubmit = (event) => {
    let payload = new AccountInterestTieringPayload(this.state.currentSweepInstruction);
    payload.setPayload(this.state, this.updateAccountLimitTiers);

    const { glsId } = (this.props.match && this.props.match.params) || {}
    const apiUrl = `/sows/${glsId}/glses`

    eapiClient(apiUrl, {
      method: 'PUT',
      data: JSON.stringify({
        cashConcentration: {
          accountInterestLimits: payload.accountInterestLimits
        }
      })
    })
      .then(({ data }) => {
        if (data.responseData && data.responseData.cashConcentration && Array.isArray(data.responseData.cashConcentration.accountInterestLimits)) {
          this.setState({
            accountInterestLimits: data.responseData.cashConcentration.accountInterestLimits
          })
        }
        this.loadSweepInstructionTabStatus();
      });
  }

  // CCR Interest Save & Refresh Click
  onCcrInfoTabDataSubmit = (event) => {
    let payload = new CcrInfoPayload(this.state.currentSweepInstruction);
    payload.setPayload(this.state, this.updateCCRTiers);

    const { glsId } = (this.props.match && this.props.match.params) || {}
    const apiUrl = `/sows/${glsId}/glses`

    eapiClient(apiUrl, {
      method: 'PUT',
      data: JSON.stringify({
        cashConcentration: {
          sweepInstructions: [payload.sweepInstruction]
        }
      })
    })
      .then(({ data }) => {
        this.loadSweepInstructionTabStatus();
      });
  }

  // CCR Bilateral Limits Save & Refresh Click
  onCcrBilateralLimitsTabDataSubmit = (event) => {
    let payload = new CcrBilateralLimitsPayload(this.state.currentSweepInstruction);
    payload.setPayload(this.state);

    const { glsId } = (this.props.match && this.props.match.params) || {}
    const apiUrl = `/sows/${glsId}/glses`

    eapiClient(apiUrl, {
      method: 'PUT',
      data: JSON.stringify({
        cashConcentration: {
          sweepInstructions: [payload.sweepInstruction]
        }
      })
    })
      .then(({ data }) => {
        this.loadSweepInstructionTabStatus();
      });
  }

  // Main Submit
  toNextpage = () => {
    let payload = new SaveAndReturnPayload(this.state.currentSweepInstruction);
    payload.setPayload(this.state, this.updateAccountLimitTiers, this.updateCCRTiers);
    this.props.reSetNewSweepActiveTabIndex()
    const { glsId } = this.props.match.params;
    const apiUrl = `/sows/${glsId}/glses`

    eapiClient(apiUrl, {
      method: 'PUT',
      data: JSON.stringify({
        cashConcentration: {
          sweepInstructions: [payload.sweepInstruction],
          accountInterestLimits: payload.accountInterestLimits
        }
      })
    }).then(({ data }) => {
      this.props.history.push(`/sow/body/cash-con-summary/` + glsId);
    });
  }

  getTabIndex = (index) => {
    this.props.setSowNewSweepActiveTabIndex(index);
  }

  renderEachAccountInterestAndTiering = (accountInterestLimit = {}, index) => {
    let formData = {};
    let lendingLimitBreachAction = {
      name: "N/A",
      value: "na"
    }
    let borrowingLimitBreachAction = {
      name: "N/A",
      value: "na"
    }

    if (accountInterestLimit !== undefined && accountInterestLimit.id !== undefined) {
      formData = { ...accountInterestLimit }
      if ("odLimit" in accountInterestLimit === false) {
        formData['odLimit'] = 'N/A';
      }
      if ("unauthorizedInterestType" in accountInterestLimit === false) {
        formData['unauthorizedInterestType'] = 'floating'
      }
      if ("lendingLimit" in accountInterestLimit === false) {
        formData['lendingLimit'] = 'N/A'
      }
      if ("borrowingLimit" in accountInterestLimit === false) {
        formData['borrowingLimit'] = 'N/A'
      }
      if ('lendingLimitBreachAction' in formData === false) {
        formData.lendingLimitBreachAction = lendingLimitBreachAction;
      } if ('borrowingLimitBreachAction' in formData === false) {
        formData.borrowingLimitBreachAction = borrowingLimitBreachAction;
      }
      if ('unauthorizedOD' in formData) {
        formData.unauthorizedOD.rate = formData.unauthorizedOD.rate ? formData.unauthorizedOD.rate : 'fixed';
      }
      else {
        formData.unauthorizedOD = { rate: 'fixed' };
      }

    } else {
      formData['odLimit'] = 'N/A';
      formData['borrowingLimit'] = 'N/A';
      formData['unauthorizedInterestType'] = 'floating'
      formData['lendingLimit'] = 'N/A'
      formData.lendingLimitBreachAction = lendingLimitBreachAction;
      formData.borrowingLimitBreachAction = borrowingLimitBreachAction;
      formData.unauthorizedOD.rate = 'fixed';

    }

    // const { location } = accountInterestLimit
    const accountObject = this.state.availableAccountsList.find(acc => acc.id === accountInterestLimit.accountId) || {}
    const entityObject = this.props.sowEntityList.find(en => en.id === accountObject.sowEntityId) || {}
    const formHeader = (
      <div className="form-header">
        <label className="form-header__label-1">
          {safeGet(accountObject, "accountNumber") !== undefined ? safeGet(accountObject, "accountNumber") + ', ' : ''}
          {
            typeof accountObject.location === "string" ?
              safeGet(accountObject, "location") !== undefined ? safeGet(accountObject, "location") + ", " : '' : null
          }
          {
            typeof accountObject.location === "string" ?
              safeGet(accountObject, "countryOfIncorporation.name") !== undefined ? safeGet(accountObject, "countryOfIncorporation.name") + ", " : ''
              :
              safeGet(accountObject, "location.name") !== undefined ? safeGet(accountObject, "location.name") + ", " : ''
          }
          {safeGet(accountObject, "currency.name") !== undefined ? safeGet(accountObject, "currency.name") : ''}
        </label>
        <label className="form-header__label-2">
          {safeGet(entityObject, "registeredName") !== undefined ? safeGet(entityObject, "registeredName") : ''}
        </label>
      </div>
    );
    const properties = {
      glsCashconId: this.props.match.params.productId,
      caseId: this.props.match.params.caseId,
      formData,
      editType: 'gls-cashcon-aacount-interest-and-limits',
      pathname: this.props.history.location.pathname
    };
    if (this.state.pageJson !== undefined && this.state.pageJson.par.aemform_accountInterestLimits !== undefined) {
      const aemform = this.state.pageJson.par.aemform_accountInterestLimits;
      const formRef = this.state.pageJson.par.aemform_accountInterestLimits.formRef;
      if (aemform !== undefined && formRef !== undefined) {
        const url = FORM_REFS[formRef];
        return (
          <Dynamicform mode="edit" key={accountInterestLimit.id}
            properties={properties}
            hideButtons={true}
            getFormData={this.getAccountInterestTieringData.bind(this, index)}
            history={this.props.history}
            fieldPrefix={accountInterestLimit.id}
            formHeader={formHeader}
            url={url}
            lang={this.props.lang.currentLang.lang}
            translatedData={this.props.lang.translatedData}
            sow
            customer={this.props.customer}
            isCustAck={this.state.isCustAck}
            getFormSchema={(formSchema) => {
              this.setState({
                accountLimitsFormSchema: formSchema
              })
            }}
          />
        );
      }
    }
  }

  isRenderAccountTiering = () => {
    return this.state.accountInterestLimits && this.state.accountInterestLimits.length &&
      (
        this.state.accountInterestLimits.findIndex(acc => acc.accountId === this.state.sweepParticipantsAccounts.masterAccount) > -1 ||
        this.state.accountInterestLimits.findIndex(acc => acc.accountId === this.state.sweepParticipantsAccounts.subAccount) > -1
      )
  }

  updateAccountLimitTiers = (accountLimitData = {}) => {
    const accountLimitObject = { ...accountLimitData }
    const formCondition = {
      accountInterestCreditTiers: "tiersCredit",
      accountInterestDebitTiers: "tiersDebit",
      odLimitTier: "tiersUnauthorizedOD"
    }
    Object.keys(formCondition).map(key => {
      if (accountLimitObject[key] && accountLimitObject[formCondition[key]]) {
        accountLimitObject[key] = this.updateTiers(accountLimitObject[key], accountLimitObject[formCondition[key]])
        delete accountLimitObject[formCondition[key]]
      }
    })
    return this.resetDataBasedOnTierStatus(accountLimitObject)
  }

  updateTiers = (tiersData = [], ccrRateTiers = []) => {
    return tiersData.map((tier, tierIndex) => {
      return { ...tier, ...ccrRateTiers[tierIndex] }
    })
  }


  updateCCRTiers = (ccrTiersData = {}) => {
    const ccrInfo = { ...ccrTiersData }
    const formCondition = {
      interestEarnTiers: "tiersInterestEarnings",
      interestChargeTiers: "tiersInterestCharges",
    }
    Object.keys(formCondition).map(key => {
      if (ccrInfo[key] && ccrInfo[formCondition[key]]) {
        ccrInfo[key] = this.updateTiers(ccrInfo[key], ccrInfo[formCondition[key]])
        delete ccrInfo[formCondition[key]]
      }
    })
    if (ccrInfo.ccrRefId && typeof ccrInfo.ccrRefId === "string" && ccrInfo.ccrRefId.trim().split(" ").length <= 1) {
      ccrInfo.ccrRefId = ' '
    }
    return this.resetDataBasedOnTierStatus(ccrInfo)
  }

  resetDataBasedOnTierStatus = (tierData = {}) => {
    const updatedTierData = { ...tierData }
    const resetCondition = {
      accountCreditTierStatus: {
        notiering: ["accountInterestCreditTiers", []],
        incremental: ["credit", { interestRateType: "baseRate", rate: "fixed" }],
        cumulative: ["credit", { interestRateType: "baseRate", rate: "fixed" }]
      },
      accountDebitTierStatus: {
        notiering: ["accountInterestDebitTiers", []],
        incremental: ['debit', { interestRateType: "baseRate", rate: "fixed" }],
        cumulative: ['debit', { interestRateType: "baseRate", rate: "fixed" }]
      },
      odLimitTierStatus: {
        notiering: ['odLimitTier', []],
        incremental: ["unauthorizedOD", { interestRateType: "baseRate", rate: "fixed" }],
        cumulative: ["unauthorizedOD", { interestRateType: "baseRate", rate: "fixed" }]
      },
      interestEarnTierStatus: {
        notiering: ['interestEarnTiers', []],
        incremental: ["interestEarnings", { interestRateType: "baseRate", rate: "fixed" }],
        cumulative: ["interestEarnings", { interestRateType: "baseRate", rate: "fixed" }]
      },
      interestChargesTierStatus: {
        notiering: ['interestChargeTiers', []],
        incremental: ["interestCharges", { interestRateType: "baseRate", rate: "fixed" }],
        cumulative: ["interestCharges", { interestRateType: "baseRate", rate: "fixed" }]
      }
    }
    Object.keys(resetCondition).map(key => {
      const resetObject = resetCondition[key]
      if (updatedTierData[key]) {
        if (resetObject[updatedTierData[key]]) {
          const [keyToUpdate, value] = resetObject[updatedTierData[key]]
          if (keyToUpdate) {
            updatedTierData[keyToUpdate] = value
          }
        }
      }
    })
    return updatedTierData
  }

  render() {
    let otherSweepInstructionsIndex = '';
    let ccrInterestIndex = '';
    let ccrBilateralLimitsIndex = '';
    if (this.state.pageJson && this.state.currentSweepInstruction.id !== undefined) {
      otherSweepInstructionsIndex = (this.state.sweepParticipantsAccounts && this.state.sweepParticipantsAccounts.sweepType && this.showOtherSweepInstructionsForm() ? 4 : 3);
    }
    if (otherSweepInstructionsIndex === 3) {
      ccrInterestIndex = 4;
      ccrBilateralLimitsIndex = 5;
    } else {
      ccrInterestIndex = 5;
      ccrBilateralLimitsIndex = 6;
    }

    return (
      this.state.pageJson && this.state.currentSweepInstruction.id ? (
        <div className="sweep-instruction-container">
          <div className="pannel-heading-container">
            <h2 className="pannel-heading">
              {(this.state.currentSweepInstruction && this.state.currentSweepInstruction.sweepId) || ''}
              {
                this.state.sweepParticipantsAccounts && this.state.sweepParticipantsAccounts.currency ?
                  `(${this.state.sweepParticipantsAccounts.currency.name})` : ''
              }
            </h2>
            <p className="optional-text">{this.translations(this.state.pageJson.par.page_title_mainTitle.descriptionText)}</p>
          </div>
          <div className="gdocs-clear-float"></div>
          <NavListAccordionWrapper open={this.state.displayTabIndex == 0}>
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={`1. ${this.translations(this.state.pageJson.par.dynamic_accordion_list_sweepInstructions.accordion1)}`}
              status={typeof this.props.sowCashConTabStatus !== 'undefined' && this.props.sowCashConTabStatus.sweepParticipantsAndAccounts.status}
              _onClick={() => {
                console.log("clicked")
                this.setState({
                  displayTabIndex: 0
                })
              }}
            >
              {this.renderSweepParticipantsAndAccountsForm()}
            </NavListAccordion>
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={`2. ${this.translations(this.state.pageJson.par.dynamic_accordion_list_sweepInstructions.accordion2)}`}
              status={typeof this.props.sowCashConTabStatus !== 'undefined' && this.props.sowCashConTabStatus.standardSweepInstructions.status}
              _onClick={this.getTabIndex.bind(this, '1')}
            >
              <div className="standard-sweep-instructions-section">
                {
                  this.renderStandardSweepInstructionsForm()
                }
              </div>
            </NavListAccordion>
            {
              this.state.sweepParticipantsAccounts && this.state.sweepParticipantsAccounts.sweepType && this.showOtherSweepInstructionsForm()
                ? (<NavListAccordion
                  lang={this.props.lang.currentLang.lang}
                  navAccHeading={`3. ${this.translations(this.state.pageJson.par.dynamic_accordion_list_sweepInstructions.accordion3)}`}
                  key="other-sweep-instructions-accordion"
                  status={typeof this.props.sowCashConTabStatus !== 'undefined' && this.props.sowCashConTabStatus.otherSweepInstructions.status}
                  _onClick={this.getTabIndex.bind(this, '2')}
                >
                  <div className="other-sweep-instructions-section">
                    {
                      this.renderOtherSweepInstructionsForm()
                    }
                  </div>
                </NavListAccordion>)
                : null
            }
            {this.isRenderAccountTiering() ?
              <NavListAccordion
                lang={this.props.lang.currentLang.lang}
                navAccHeading={`${otherSweepInstructionsIndex}. ${this.translations(this.state.pageJson.par.dynamic_accordion_list_sweepInstructions.accordion5)}`}
                key="account-limits-tiering-accordion"
                status={typeof this.props.sowCashConTabStatus !== 'undefined' && this.props.sowCashConTabStatus.otherSweepOptions &&
                  this.props.sowCashConTabStatus.otherSweepOptions.status}
                _onClick={this.getTabIndex.bind(this, '3')}
              >
                <div className="account-limits-tiering-accordion-section">
                  {this.renderAccountInterestTieringForm()}
                </div>
              </NavListAccordion>
              : null
            }

            {
              this.state.sweepParticipantsAccounts && this.state.sweepParticipantsAccounts.cashConReporting
                ? (<NavListAccordion
                  lang={this.props.lang.currentLang.lang}
                  navAccHeading={`${ccrInterestIndex}. ${this.translations(this.state.pageJson.par.dynamic_accordion_list_sweepInstructions.accordion6)}`}
                  status={typeof this.props.sowCashConTabStatus !== 'undefined' && this.props.sowCashConTabStatus.CCRInterest.status}
                  _onClick={this.getTabIndex.bind(this, '4')}
                >
                  <div className="ccr-interest-section">
                    {
                      this.renderCCRInterestForm()
                    }
                  </div>
                </NavListAccordion>)
                : ''
            }
            {
              this.state.sweepParticipantsAccounts && this.state.sweepParticipantsAccounts.bilateralLimits
                ? (<NavListAccordion
                  lang={this.props.lang.currentLang.lang}
                  navAccHeading={`${ccrBilateralLimitsIndex}. ${this.translations(this.state.pageJson.par.dynamic_accordion_list_sweepInstructions.accordion7)}`}
                  status={typeof this.props.sowCashConTabStatus !== 'undefined' && this.props.sowCashConTabStatus.CCRBiletralLimits.status}
                  _onClick={this.getTabIndex.bind(this, '5')}
                >
                  <div className="ccr-bilateral-limits-section">
                    {
                      this.renderBilateralLimitsForm()
                    }
                  </div>
                </NavListAccordion>)
                : ''
            }
          </NavListAccordionWrapper >
          <div className="save-and-return">
            <button
              onClick={this.toNextpage}
              className='gdocs-btn-primary'
              disabled={this.isReadOnly()}
            >
              {this.translations(this.state.pageJson.par.page_title_mainTitle.text)}
            </button>
          </div>
        </div >)
        : null);
  }
}

const mapStateToProps = state => {
  return {
    currentProductGlsCashCon: state.currentProductGlsCashcon.currentProductGlsCashCon,
    entities: state.entities,
    customer: state.auth.userDetails,
    displayTabIndex: state.sowBodyReducer.sweepActiveTabIndex,
    lang: state.lang,
    sowAgent: state.sowEntities.sowAgent,
    sowEntityList: (state.sowEntities && state.sowEntities.savedSow && state.sowEntities.savedSow.entity) || [],
    savedSow: state.sowEntities && state.sowEntities.savedSow,
    caseMenu: state.caseMenuInfo
  }
}
const mapDispatchToProps = dispatch => {
  return {
    setCrossBorder: value => {
      dispatch(setCrossBorder(value));
    },
    setSowNewSweepActiveTabIndex: index => {
      dispatch(setSowNewSweepActiveTabIndex(index))
    },
    reSetNewSweepActiveTabIndex: () => {
      dispatch(reSetNewSweepActiveTabIndex())
    },
    resetCountryInfo: () => {
      dispatch(resetCountryInfo())
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(AddSweepInstruction);

// Sweep participant Account section class
class SweepPartcipantsAccountPayload {
  constructor(sweepInstruction) {
    this.sweepInstruction = sweepInstruction;
  }
  setPayload({ sweepParticipantsAccounts }) {
    if (this.sweepInstruction === undefined) {
      this.sweepInstruction = {};
    }
    if (sweepParticipantsAccounts) {
      this.sweepInstruction.sweepParticipantsAccounts = Array.isArray(sweepParticipantsAccounts) ? {} : sweepParticipantsAccounts;
    }
  }
}

// Standard Sweep Instruction  class
class StandardSweepInstructionsPayload {
  constructor(sweepInstruction) {
    this.sweepInstruction = sweepInstruction;
  }
  setPayload({ standardSweepInstructions }) {
    if (this.sweepInstruction === undefined) {
      this.sweepInstruction = {};
    }
    if (standardSweepInstructions) {
      this.sweepInstruction.standardSweepInstructions = standardSweepInstructions;
    }
  }
}

//  Other sweep Instruction Class
class OtherSweepInstructionsPayload {
  constructor(sweepInstruction) {
    this.sweepInstruction = sweepInstruction;
  }
  setPayload({ otherSweepInstructions }) {
    if (this.sweepInstruction === undefined) {
      this.sweepInstruction = {};
    }
    if (otherSweepInstructions) {
      this.sweepInstruction.otherSweepInstructions = otherSweepInstructions;
    }
  }
}

// Account Interest Tiering class
class AccountInterestTieringPayload {
  constructor(sweepInstruction) {
    this.sweepInstruction = sweepInstruction;
  }
  setPayload({ accountInterestLimits = [] }, updateAccountLimitTiers) {
    if (this.sweepInstruction === undefined) {
      this.sweepInstruction = {};
    }
    if (accountInterestLimits) {
      this.accountInterestLimits = accountInterestLimits.map(acc => updateAccountLimitTiers(acc));
    }
  }
}

// CCR Interest class
class CcrInfoPayload {
  constructor(sweepInstruction) {
    this.sweepInstruction = sweepInstruction;
  }
  setPayload({ ccrInfo }, updateCCRTiers) {
    if (this.sweepInstruction === undefined) {
      this.sweepInstruction = {};
    }
    if (ccrInfo) {
      this.sweepInstruction.ccrInfo = updateCCRTiers(ccrInfo);
    }
  }
}

// CCR Bilateral Limits class
class CcrBilateralLimitsPayload {
  constructor(sweepInstruction) {
    this.sweepInstruction = sweepInstruction;
  }
  setPayload({ ccrBilateralLimits }) {
    if (this.sweepInstruction === undefined) {
      this.sweepInstruction = {};
    }
    if (ccrBilateralLimits) {
      this.sweepInstruction.ccrBilateralLimits = ccrBilateralLimits;
    }
  }
}

// Main Class
class SaveAndReturnPayload {
  constructor(sweepInstruction) {
    this.sweepInstruction = sweepInstruction;
  }
  setPayload({ sweepParticipantsAccounts, standardSweepInstructions, otherSweepInstructions, accountInterestLimits = [], ccrInfo, ccrBilateralLimits }, updateAccountLimitTiers, updateCCRTiers) {
    if (this.sweepInstruction === undefined) {
      this.sweepInstruction = {};
    }
    if (sweepParticipantsAccounts) {
      this.sweepInstruction.sweepParticipantsAccounts = Array.isArray(sweepParticipantsAccounts) ? {} : sweepParticipantsAccounts
    }
    if (standardSweepInstructions) {
      this.sweepInstruction.standardSweepInstructions = standardSweepInstructions;
    }
    if (otherSweepInstructions) {
      this.sweepInstruction.otherSweepInstructions = otherSweepInstructions;
    }
    if (accountInterestLimits) {
      this.accountInterestLimits = accountInterestLimits.map(acc => updateAccountLimitTiers(acc));
    }
    if (ccrInfo) {
      this.sweepInstruction.ccrInfo = updateCCRTiers(ccrInfo);
    }
    if (ccrBilateralLimits) {
      this.sweepInstruction.ccrBilateralLimits = ccrBilateralLimits;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/SowBody/GLSProduct/CaptureSweepInstructions/AddSweepInstruction/index.js